// project import
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => (
  <SimpleBar
    sx={{
      '& .simplebar-content': {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f0f0f0',
        borderRight: 'none !important',
      }
    }}
  >
    <Navigation />
  </SimpleBar>
);

export default DrawerContent;
